export interface InstallmentSettings {
  maxInstallments: number;
  minInstallmentValue: number;
  installmentsWithoutInterest: boolean;
}

export interface InstallmentInfo {
  count: number;
  amount: number;
}

export function getPixPrice(price: number, pixDiscountPercentage: number): number | null {
  if (pixDiscountPercentage <= 0) return null;
  return price * (1 - pixDiscountPercentage / 100);
}

export function getInstallmentInfo(price: number, settings: InstallmentSettings): InstallmentInfo | null {
  if (settings.minInstallmentValue <= 0) return null;
  for (let count = settings.maxInstallments; count >= 2; count--) {
    const amount = price / count;
    if (amount >= settings.minInstallmentValue) {
      return { count, amount };
    }
  }
  return null;
}
